var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-xl g-0 g-lg-2", class: [_vm.containerClass] },
    [
      _c("div", { staticClass: "row h-100 g-0 g-lg-2" }, [
        _c("div", { staticClass: "col h-100" }, [
          _c(
            "div",
            {
              staticClass: "header-small d-flex",
              style: { backgroundImage: `url(${this.headerbg}) !important` },
            },
            [
              _vm.title
                ? [
                    _vm.headlineType === "h1"
                      ? _c("h1", { class: [_vm.classProp] }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.title) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.headlineType === "h2"
                      ? _c("h2", { class: [_vm.classProp] }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.title) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }